import { render, staticRenderFns } from "./IconsLoading.vue?vue&type=template&id=1dd6d472"
import script from "./IconsLoading.vue?vue&type=script&lang=js"
export * from "./IconsLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd6d472')) {
      api.createRecord('1dd6d472', component.options)
    } else {
      api.reload('1dd6d472', component.options)
    }
    module.hot.accept("./IconsLoading.vue?vue&type=template&id=1dd6d472", function () {
      api.rerender('1dd6d472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/loaders/IconsLoading.vue"
export default component.exports